<template>
  <div class="w-100 d-flex flex-column" style="gap: 24px;">
    <div class="title">
      <h5>{{ $t("views.seller.my_account.text_1253") }}</h5>
      <p>{{ $t("views.seller.my_account.text_1254") }}</p>
    </div>

    <b-form data-vv-scope="credential" @submit.prevent="handleSubmit()">
      <b-col cols="6" class="p-0">
        <div class="d-flex flex-column" style="gap: 24px;">
          <b-row>
            <b-col cols="12">
              <BaseInput id="password" 
                name="password" 
                type="password" 
                v-model="credential.oldPassword"
                :type="showOldPassword ? 'text' : 'password'"
                v-validate="'required'" 
                :placeholder="$t('views.seller.my_account.text_1258')"
                :label="$t('views.seller.my_account.text_1255')" 
                :isValid="!errors.has('credential.password')"
                :errorMessage="$t('seller.my_account.reset_password.text_307')">
              </BaseInput>
              <span
                class="show-password"
                @click="() => showOldPassword = !showOldPassword"
              >
                {{ showOldPassword ? $t('views.seller.password_recovery.text_1476') : $t('views.seller.password_recovery.text_1474') }}
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <BaseInput 
                id="new_password" 
                name="new_password" 
                type="password" 
                v-validate="'required|min:8'"
                v-model="credential.newPassword" 
                :label="$t('views.seller.my_account.text_1256')"
                :placeholder="$t('views.seller.my_account.text_1259')" :isValid="!errors.has('credential.new_password')"
                :errorMessage="$t('seller.my_account.reset_password.text_309')"
                :type="showNewPassword ? 'text' : 'password'"
              >
              </BaseInput>
              <span
                class="show-password"
                @click="() => showNewPassword = !showNewPassword"
              >
                {{ showNewPassword ? $t('views.seller.password_recovery.text_1476') : $t('views.seller.password_recovery.text_1474') }}
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="d-flex justify-content-end" style="gap: 16px">
              <BaseNewButton variant="secondary" type="button" @click.prevent="clearData">{{
                $t("views.seller.my_account.text_1257")
                }}</BaseNewButton>
              <BaseNewButton variant="primary" icon="tick-outline" iconPosition="left" type="submit">{{
                $t("views.seller.my_account.text_1174")
                }}</BaseNewButton>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-form>
  </div>
</template>

<script>
import UserService from "@/services/resources/UserService";

const serviceUser = UserService.build();

export default {
  name: 'SecurityTab',
  props: {
    user: {
      type: Object
    },
  },
  data() {
    return {
      credential: {
        id: -1,
        oldPassword: '',
        newPassword: ''
      },
      showOldPassword: false,
      showNewPassword: false
    }
  },
  computed: {
    userId() {
      return this.$store.getters.getProfile.id;
    }
  },
  methods: {
    handleSubmit() {
      this.loading = true;
      this.submit = true;

      this.$validator.validateAll('credential').then(async (result) => {
        if (result) {
          serviceUser
            .update({
              old_password: this.credential.oldPassword,
              new_password: this.credential.newPassword,
              id: this.userId
            })
            .then(() => {
              this.$bvToast.toast(this.$t('seller.my_account.reset_password.text_310'), {
                title: this.$t('seller.my_account.reset_password.text_1859'),
                variant: "success",
                autoHideDelay: 5000,
                appendToast: true,
              });
              this.clear();
              this.loading = false;
              this.submit = false;
              this.$bvModal.hide("reset_password");
            })
            .catch((error) => {
              console.log(error);
              this.loading = false;
              this.submit = false;
            });
        } else {
          this.loading = false;
          this.$bvToast.toast(this.$t('seller.my_account.reset_password.text_311'), {
            title: this.$t('seller.my_account.reset_password.text_1859'),
            variant: "danger",
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      });
    },
    clearData() {
      this.credential = {
        id: -1,
        oldPassword: '',
        newPassword: '',
      };
    },
  }
};
</script>

<style scoped>
.show-password {
  font-size: 13px;
  position: absolute;
  top: 49%;
  right: 25px;
  cursor: pointer;
  color: #81858e;
}
</style>
